import * as shiftsService from '../../../../services/Shifts/shiftsService';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? shiftsService.editShiftType : shiftsService.createShiftType,
  },
});



// const config = {
//   getSubmitMethod: () => null, //set null when override the dialogActionsHelper's submit method
// };
//
// export const actionTypes = {
//   ...daHelper.getActionTypes(dialogsNames.CREATE_SHIFT_TYPE_DIALOG),
// };
//
// const actions = {
//   ...daHelper.getActions(dialogsNames.CREATE_SHIFT_TYPE_DIALOG),
// };
//
// export let api = {
//   ...daHelper.getApiActions(actions, config),
//
//   submit(dispatch, getState) {
//     return function (data, isEditMode, reloadParentComponent) {
//       dispatch(actions.setBusy(true));
//       let method = isEditMode ? shiftsService.editShiftType : shiftsService.createShiftType;
//
//       method(data).then((response) => {
//         dispatch(actions.setBusy(false));
//
//         let validations = dialogHelper.getResponseValidationDetails(response);
//         if (validations) {
//           dispatch(actions.setValidationWarningsData(validations));
//           return {success: false};
//         }
//
//         if (!Network.isResponseValid(response)) {
//           console.error('Create/Edit shift type failed', response);
//           messageDialogApi.responseError(dispatch, getState)(response);
//           return {success: false};
//         }
//
//
//         dispatch(actions.hide());
//
//         if (reloadParentComponent) {
//           reloadParentComponent();
//         }
//
//         return {success: true};
//       });
//     };
//   },
//
// };
//
// export let jsxActions = {
//   ...daHelper.getJsxActions(api),
//
//   submit(data, isEditMode, reloadParentComponent) {
//     return function(dispatch, getState) {
//       return api.submit(dispatch, getState)(data, isEditMode, reloadParentComponent);
//     };
//   },
// };
